import { useRouter } from "next/router";

import { GA_EVENT_IDS } from "@domains/common/constants/googleAnalyticsIds";
import { grayScale, pink } from "@enkor/design/colors";
import { BubbleChatIcon, Share2Icon } from "@enkor/design/icons";
import WebViewBridge from "@logics/utils/webViewBridge";
import {
  getColorButtonAnimation,
  iconButtonAnimation,
} from "@domains/common/utils/animationHelper";
import { NAVIGATION_ROUTE } from "@domains/common/constants/navigationRoute";

import * as S from "./HostClosedButtonGroup.style";

interface HostClosedButtonGroupProps {
  eventId: string;
  onClickChatRoom: () => void;
  onClickShare: () => void;
}

const HostClosedButtonGroup = ({
  eventId,
  onClickChatRoom,
  onClickShare,
}: HostClosedButtonGroupProps) => {
  const { push } = useRouter();

  const handleClickCheckAttendance = () => {
    if (WebViewBridge.isInAppWebView()) {
      WebViewBridge.getInstance().navigateToEventAttendance(eventId);
      return;
    }

    push(`${NAVIGATION_ROUTE.EVENT_DETAIL.HREF}/${eventId}/attendance`);
  };

  return (
    <S.ButtonGroupWrapper>
      <S.ShareButtonBox
        type="button"
        {...iconButtonAnimation}
        id={GA_EVENT_IDS.EVENT.GUEST_SHARE}
        onClick={onClickShare}
      >
        <Share2Icon strokeColor={grayScale.white} />
      </S.ShareButtonBox>
      <S.MessageButton
        type="button"
        {...iconButtonAnimation}
        onClick={onClickChatRoom}
      >
        <BubbleChatIcon size={24} strokeColor={grayScale.white} />
      </S.MessageButton>
      <S.FullButton
        type="button"
        {...getColorButtonAnimation({
          hoverColor: pink[300],
          tapColor: pink[200],
        })}
        onClick={handleClickCheckAttendance}
      >
        Take roll call
      </S.FullButton>
    </S.ButtonGroupWrapper>
  );
};

export default HostClosedButtonGroup;
